import React from 'react'
import {Link} from 'react-router-dom'
import {Button, Stack, Typography} from '@mui/material'

const ExerciseCard = ({exercise}) => {
  return (
    <Link 
    className='exercise-card'
    to={`/exercise/${exercise.id}`}>
        <img src={exercise.gifUrl} alt={exercise.name} loading='lazy'/>
        <Stack direction='row'>
            <Button sx={{ml: '21px', color:'white', background:'#5C9C31', 
        fontSize:'16px', borderRadius:'20px', textTransform:'capitalize'}}>
            {exercise.target}
            </Button>
        </Stack>
        <Typography ml='21px' color='black' fontWeight='bold' mt='11px' pb='10px' textTransform='capitalize' fontSize='24px'>
            {exercise.name}
        </Typography>
    </Link>
  )
}

export default ExerciseCard